import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
const notifications = [{
  name: 'María G.',
  time: 'hace 3 minutos',
  province: 'Buenos Aires'
}, {
  name: 'Juan P.',
  time: 'hace 14 minutos',
  province: 'Córdoba'
}, {
  name: 'Valentina R.',
  time: 'hace 7 minutos',
  province: 'Mendoza'
}, {
  name: 'Carlos M.',
  time: 'hace 23 minutos',
  province: 'Santa Fe'
}, {
  name: 'Ana L.',
  time: 'hace 11 minutos',
  province: 'Tucumán'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 1000);
    }, 40000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(cycleInterval);
    };
  }, []);
  useEffect(() => {
    if (isVisible) {
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimer);
    }
  }, [isVisible]);
  return <div className="fixed bottom-24 sm:bottom-6 left-4 sm:left-6 z-50 pointer-events-none" data-id="element-224">
      <AnimatePresence data-id="element-225">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25
      }} className="bg-[#1E0A3C] border border-[#7C3AED]/30 shadow-lg shadow-[#7C3AED]/10 rounded-xl p-3 sm:p-4 flex items-center gap-3 sm:gap-4 max-w-[300px] sm:max-w-sm backdrop-blur-md" data-id="element-226">
            <div className="bg-[#7C3AED]/20 rounded-full p-1.5 sm:p-2 flex-shrink-0" data-id="element-227">
              <ShoppingCartIcon className="w-5 h-5 sm:w-6 sm:h-6 text-[#7C3AED]" data-id="element-228" />
            </div>
            <div data-id="element-229">
              <p className="text-white font-semibold text-sm sm:text-base font-sans leading-tight" data-id="element-230">
                {notifications[currentIndex].name}
              </p>
              <p className="text-[#C4B5FD] text-xs sm:text-sm font-sans mt-0.5" data-id="element-231">
                compró {notifications[currentIndex].time}
              </p>
              <p className="text-[#A78BFA] text-xs font-sans mt-0.5" data-id="element-232">
                📍 {notifications[currentIndex].province}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}